import ProjectData from '@/data/ProjectData.ts'

export default [
    new ProjectData("project-1", "Call of Duty: Modern Warfare III", "img/projects/project-1-icon.png",
    `
    <div class="paragraph" xmlns="http://www.w3.org/1999/html">
     <strong>Modern Warfare III</strong> is the most monumental game I've worked on to date. I worked specifically on the zombies mode at Sledgdehammer Games.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/jWHVyeeoMdE" frameborder="0" allowfullscreen></iframe>
    </div>

    <div class="paragraph">
        Position - Associate Technical Designer </br></br>
        Responsibilities: 
        <ul>
        <li>Design gameplay functionality in collaboration with other designers</li>
        <li>Implement features and fix bugs that arise using CODEngine and the GSC programming language</li>
        <li>Write clean and optimal code to company standards (both style and performance)</li>
        <li>Work in an Agile framework</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/rainmaker.png" alt="MWIII Rainmaker Screenshot" />
        <img class="pc-screenshot" src="img/zombies.png" alt="MWIII Zombies Screenshot" />
    </div>
    `, "#23bd69", true),
    new ProjectData("project-2", "Xfinity Android App", "img/projects/project-2-icon.png", `
    <div class="paragraph">
        <strong>I worked on the Xfinity Android application on features related to home internet connectivity.
    </div>

    <div class="paragraph">
        Position - Application Developer </br></br>
        Responsibilities: 
        <ul>
        <li> Designed, implemented, and maintained new features and experiences in the Xfinity Android app using a combination of C# and .NET and native Java and Kotlin</li>
        <li>Collaborated closely with iOS and Backend engineers, Product Owners, Designers, and Business Stakeholders on project</li>
        <li>Participated in and supported bi-weekly Play Store releases to millions of users, closely monitoring product stability, feature releases, analytics, and experiments</li>
        <li>Worked with the latest Jetpack & Kotlin tools and frameworks</li>
        </ul>
    </div>

    <div class="paragraph center">
    <img class="phone-screenshot" src="https://play-lh.googleusercontent.com/LTXFF6WHmC5yDZ82Ubc4nX95SKEfdm0M8z9nSXoZ9F6CBhuq0YepfNLht2yNRynMFw=w2560-h1440" alt="Xfinity Screenshot" />
    <img class="phone-screenshot" src="https://play-lh.googleusercontent.com/o_pjHfEQL3SHTGgO5xFtsjffooGe9KtR2cKWn6J7W7cIkBQ4tMyt22vEF0q7UvUjgQ=w2560-h1440" alt="Xfinity Screenshot" />
    </div>
    `, "#5a78af"),
    new ProjectData("project-3", "Ford Android App", "img/projects/project-3-icon.png", `
    <div class="paragraph">
        The <strong>Ford Android Application</strong> was an excellent challenge with the reliance on dependency injections.
    </div>

    <div class="paragraph">
        Position - Application Developer </br></br>
        Responsibilities: 
        <ul>
        <li>Developed Android applications from conception to production for drivers and vehicles around the world using native Java</li>
        <li>Actively participated in reviewing, evaluating, and providing feedback on product designs and architectures with a software engineering focus</li>
        <li>Wrote and contributed to high-quality documentation for software engineers</li>
        <li>Worked effectively with product managers, product designers, and other technical expert</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="phone-screenshot" src="https://play-lh.googleusercontent.com/BjlU0tzp6O2Ntyqgdb2VuIvCBKVAqWhjR64EmjTy2NSzLc8GTgu_48_3JKYsQF4xkig=w2560-h1440" alt="Ford Screenshot" />
        <img class="phone-screenshot" src="https://play-lh.googleusercontent.com/7YDLoW8ThriFx7XceVgOtuLTx2dyCUXZu6HWJRqUM8Tkq5vqas9deU2E87vec3R67mI=w2560-h1440" alt="Ford Screenshot" />
    </div>
    `, "#383838"),
    new ProjectData("project-4", "MGS Casino Games", "img/projects/project-4-icon.png", `
    <div class="paragraph">
    At <strong>MGS</strong> (Makro Gaming Studios and formerly Meta Gaming Studios), I ported numerous casino titles from cabinet format to mobile using Unity and C#.
    </div>
    
    <div class="paragraph">
        Position - Unity Developer </br></br>
        Responsibilities: 
        <ul>
        <li>Collaborated with artists to ensure uniformity across mobile and machine game</li>
        <li>Worked around mobile device limitations to ensure a smooth transition from physical machine to Android and iOS</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="phone-screenshot" src="https://winmgs.com/images/N4cabinet.png" alt="MGS Screenshot" />
        <img class="phone-screenshot" src="https://winmgs.com/images/N5cabinet.png" alt="MGS Screenshot" />
    </div>
    `, "#e80fb7"),
    new ProjectData("project-5", "UMG Gaming Android App", "img/projects/project-5-icon.png", `
    <div class="paragraph">
        <strong>UMG Gaming</strong> was an android app made from start to finish for large-scale eSports tournaments.
    </div>
    
    <div class="paragraph">
        Position - Application Developer </br></br>
        Responsibilities: 
        <ul>
        <li>Designed and implemented features for an eSports management Android application</li>
        <li>Collaborated with product and design teams to optimize the mobile user experience</li>
        <li>Resolved design and development issues as they arose, ensuring the inclusion of a business vision and adjusting to new industry trends</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="phone-screenshot" src="https://resource.globenewswire.com/Resource/Download/7a7181e0-8ba8-47cc-b062-f3384125748d" alt="UMG Gaming Screenshot" />
        <img class="phone-screenshot" src="https://resource.globenewswire.com/Resource/Download/2abd7d44-12ed-43cd-966d-8899a38a9388" alt="UMG Gaming Screenshot" />
    </div>`, "#e48246"),
    new ProjectData("project-6", "PacketBall", "https://www.thefastmode.com/media/k2/items/cache/661cde5aa26fef2fd51a929fda6950fe_XL.jpg?t=20171124_025427", `
    <div class="paragraph">
        During an internship with a startup called PacketZoom, I developed a demo game <strong>PacketBall</strong> to demonstrate the company's networking plugin to investors.
    </div>
    
    <div class="paragraph">
        Position - Unity Developer </br></br>
        Responsibilities: 
        <ul>
        <li>Designed and created a mobile game from start to finish</li>
        <li>Worked with networking engineers and the marketing team for an accurate representation of the product</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="https://www.superbcrew.com/wp-content/uploads/2017/02/PacketZoom_Featured2.jpg" alt="PacketZoom Screenshot" />
        <img class="phone-screenshot" src="https://devops.com/wp-content/uploads/2015/04/packetzoom.jpg" alt="PacketZoom Screenshot" />
    </div>`, "#e48246")
];